import type { SalesRevenueResponse } from "../../api/dashboardApi";

import goldMedal from "../../assets/img/top1.png";
import silverMedal from "../../assets/img/top2.png";
import bronzeMedal from "../../assets/img/top3.png";

interface SalesRevenueTableProps {
  data: SalesRevenueResponse;
}





const MEDALS = [goldMedal, silverMedal, bronzeMedal];

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value);

export default function SalesRevenueTable({ data }: SalesRevenueTableProps) {
  return (
    <div className="rounded-2xl bg-white p-6 shadow-sm">
      <h3 className="font-semibold text-[#324A5A]">
        Penjualan Per Sales (Total)
      </h3>
      <p className="mt-0.5 text-sm text-slate-400">Periode sesuai filter</p>

      <div className="mt-5 overflow-x-auto">
        <table className="w-full min-w-[900px] text-sm">
          <thead>
            <tr className="bg-[#3DA4A8] text-white">
              <th
                rowSpan={2}
                className="px-4 py-3 text-left align-bottom font-medium">
                Nama Sales
              </th>
              <th
                colSpan={data.periods.length}
                className="px-4 py-2 text-center font-medium">
                Total Invoice (Paid)
              </th>
              <th
                rowSpan={2}
                className="px-4 py-3 text-center align-bottom font-medium">
                Total Pendapatan
              </th>
            </tr>
            <tr className="bg-[#3DA4A8] text-white">
              {data.periods.map((period) => (
                <th
                  key={period.key}
                  className="px-2 py-2 text-center text-xs font-medium">
                  {period.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.rows.map((row, index) => (
              <tr key={row.salesId} className="border-t border-slate-100">
                <td className="flex items-center gap-2 px-4 py-3 font-medium text-[#324A5A]">
                  <span>{row.salesName}</span>
                  {index < 3 && (
                    <img
                      src={MEDALS[index]}
                      alt={`Rank ${index + 1}`}
                      className="w-6 h-6"
                    />
                  )}
                </td>

                {row.monthly.map((count, index) => (
                  <td
                    key={data.periods[index].key}
                    className="px-2 py-3 text-center text-slate-500">
                    {count}
                  </td>
                ))}

                <td className="px-4 py-3 text-right font-semibold text-[#324A5A]">
                  {formatCurrency(row.totalRevenue)}
                </td>
              </tr>
            ))}

            {data.rows.length === 0 && (
              <tr>
                <td
                  colSpan={data.periods.length + 2}
                  className="px-4 py-8 text-center text-slate-400">
                  Belum ada data penjualan.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
